import types from '../types'

const initialState = {
  getHealthSystem: {
    loading: false,
    success: false,
    error: false,
    data: []
  },
  healthSystem: {},
  getContent: {
    loading: false,
    success: false,
    error: false,
    data: []
  },
  content: [],
  getHealthSystems: {
    loading: false,
    success: false,
    error: false
  },
  healthSystems: [],
  createHealthSystem: {
    loading: false,
    success: false,
    error: false
  },
  getUsers: {
    loading: false,
    success: false,
    error: false
  },
  users: [],
  createUser: {
    loading: false,
    success: false,
    error: false
  },
  updateUser: {
    loading: false,
    success: false,
    error: false
  },
  deleteUser: {
    loading: false,
    success: false,
    error: false
  },
  getRules: {
    loading: false,
    success: false,
    error: false
  },
  rules: [],
  updateRule: {
    loading: false,
    success: false,
    error: false
  },
  addRuleAction: {
    loading: false,
    success: false,
    error: false
  },
  deleteRuleAction: {
    loading: false,
    success: false,
    error: false
  },
  getActions: {
    loading: false,
    success: false,
    error: false
  },
  actions: [],
  activeActionSort: 'name',
  isDesc: false,
  addAction: {
    loading: false,
    success: false,
    error: false,
  },
  updateAction: {
    loading: false,
    success: false,
    error: false,
  },
  deleteAction: {
    loading: false,
    success: false,
    error: false
  },
  resendSetup: {
    loading: false,
    success: false,
    error: false
  },
  reportData: {},
  getReport: {
    loading: false,
    success: false,
    error: false
  }
}

const healthSystemReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.GET_HEALTH_SYSTEMS_REQUESTED: {
    return {
      ...state,
      getHealthSystems: {
        loading: true,
        success: false,
        error: false
      },
      healthSystems: []
    }
  }
  case types.GET_HEALTH_SYSTEMS_FULFILLED: {
    return {
      ...state,
      getHealthSystems: {
        ...state.getHealthSystems,
        loading: false,
        success: true,
      },
      healthSystems: action.payload
    }
  }
  case types.GET_HEALTH_SYSTEMS_REJECTED: {
    return {
      ...state,
      getHealthSystems: {
        ...state.getHealthSystems,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.CREATE_HEALTH_SYSTEM_REQUESTED: {
    return {
      ...state,
      createHealthSystem: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.CREATE_HEALTH_SYSTEM_FULFILLED: {
    return {
      ...state,
      createHealthSystem: {
        ...state.createHealthSystem,
        loading: false,
        success: true
      },
      healthSystems: [
        ...state.healthSystems,
        action.payload
      ]
    }
  }
  case types.CREATE_HEALTH_SYSTEM_REJECTED: {
    return {
      ...state,
      createHealthSystem: {
        ...state.createHealthSystem,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.GET_HEALTH_SYSTEM_REQUESTED: {
    return {
      ...state,
      getHealthSystem: {
        loading: true,
        success: false,
        error: false,
        data: []
      }
    }
  }
  case types.GET_HEALTH_SYSTEM_FULFILLED: {
    return {
      ...state,
      getHealthSystem: {
        ...state.getHealthSystem,
        loading: false,
        success: true,
        data: action.payload
      },
      healthSystem: action.payload
    }
  }
  case types.GET_HEALTH_SYSTEM_REJECTED: {
    return {
      ...state,
      getHealthSystem: {
        ...state.getHealthSystem,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.GET_CONTENT_REQUESTED: {
    return {
      ...state,
      getContent: {
        loading: true,
        error: false,
        success: false,
        data: []
      }
    }
  }
  case types.GET_CONTENT_FULFILLED: {
    return {
      ...state,
      getContent: {
        ...state.getContent,
        loading: false,
        success: true,
        data: action.payload
      },
      content: action.payload
    }
  }
  case types.GET_CONTENT_REJECTED: {
    return {
      ...state,
      getContent: {
        ...state.getContent,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.GET_HEALTH_SYSTEM_USERS_REQUESTED: {
    return {
      ...state,
      getUsers: {
        loading: true,
        success: false,
        error: false
      },
      users: []
    }
  }
  case types.GET_HEALTH_SYSTEM_USERS_FULFILLED: {
    return {
      ...state,
      getUsers: {
        ...state.getUsers,
        loading: false,
        success: true,
      },
      users: action.payload
    }
  }
  case types.GET_HEALTH_SYSTEM_USERS_REJECTED: {
    return {
      ...state,
      getUsers: {
        ...state.getUsers,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.CREATE_USER_REQUESTED: {
    return {
      ...state,
      createUser: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.CREATE_USER_FULFILLED: {
    return {
      ...state,
      createUser: {
        ...state.createUser,
        loading: false,
        success: true
      },
      users: [
        ...state.users,
        action.payload
      ]
    }
  }
  case types.CREATE_USER_REJECTED: {
    return {
      ...state,
      createUser: {
        ...state.createUser,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.UPDATE_USER_REQUESTED: {
    return {
      ...state,
      updateUser: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.UPDATE_USER_FULFILLED: {
    const { userId } = action.payload
    const userIndex = state.users.findIndex((user) => user.userId === userId)
    return {
      ...state,
      updateUser: {
        ...state.updateUser,
        loading: false,
        success: true
      },
      users: [
        ...state.users.slice(0, userIndex),
        action.payload,
        ...state.users.slice(userIndex + 1)
      ]
    }
  }
  case types.UPDATE_USER_REJECTED: {
    return {
      ...state,
      updateUser: {
        ...state.updateUser,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.DELETE_USER_REQUESTED: {
    return {
      ...state,
      deleteUser: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.DELETE_USER_FULFILLED: {
    return {
      ...state,
      deleteUser: {
        ...state.deleteUser,
        loading: false,
        success: true
      },
      users: state.users.filter((user) => user.userId !== parseInt(action.payload, 10))
    }
  }
  case types.DELETE_USER_REJECTED: {
    return {
      ...state,
      deleteUser: {
        ...state.deleteUser,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.GET_HEALTH_SYSTEM_RULES_REQUESTED: {
    return {
      ...state,
      getRules: {
        loading: true,
        success: false,
        error: false
      },
      rules: []
    }
  }
  case types.GET_HEALTH_SYSTEM_RULES_FULFILLED: {
    return {
      ...state,
      getRules: {
        ...state.getRules,
        loading: false,
        success: true
      },
      rules: action.payload
    }
  }
  case types.GET_HEALTH_SYSTEM_RULES_REJECTED: {
    return {
      ...state,
      getRules: {
        ...state.getRules,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.UPDATE_HEALTH_SYSTEM_RULE_REQUESTED: {
    return {
      ...state,
      updateRule: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.UPDATE_HEALTH_SYSTEM_RULE_FULFILLED: {
    const { opportunityId, rule } = action.payload

    const opportunityIndex = state.rules.findIndex((rule) => rule.opportunityId === opportunityId)
    const opportunity = state.rules[opportunityIndex]

    const ruleIndex = opportunity.rules.findIndex((r) => r.ruleId === rule.ruleId)
    

    const newRules = [
      ...state.rules.slice(0, opportunityIndex),
      {
        ...opportunity,
        rules: [
          ...opportunity.rules.slice(0, ruleIndex),
          rule,
          ...opportunity.rules.slice(ruleIndex + 1)
        ]
      },
      ...state.rules.slice(opportunityIndex + 1)
    ]

    return {
      ...state,
      updateRule: {
        ...state.updateRule,
        loading: false,
        success: true
      },
      rules: newRules
    }
  }
  case types.UPDATE_HEALTH_SYSTEM_RULE_REJECTED: {
    return {
      ...state,
      updateRule: {
        ...state.updateRule,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.ADD_RULE_ACTION_REQUESTED: {
    return {
      ...state,
      addRuleAction: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.ADD_RULE_ACTION_FULFILLED: {
    const { opportunityId, ruleId, ruleAction } = action.payload
    
    const opportunityIndex = state.rules.findIndex((rule) => rule.opportunityId === opportunityId)
    const opportunity = state.rules[opportunityIndex]

    const ruleIndex = opportunity.rules.findIndex((rule) => rule.ruleId === ruleId)
    const rule = opportunity.rules[ruleIndex]
    
    const newRuleActions = [
      ...rule.ruleActions,
      ruleAction
    ]

    const newRules = [
      ...state.rules.slice(0, opportunityIndex),
      {
        ...opportunity,
        rules: [
          ...opportunity.rules.slice(0, ruleIndex),
          {
            ...rule,
            ruleActions: newRuleActions
          },
          ...opportunity.rules.slice(ruleIndex + 1)
        ]
      },
      ...state.rules.slice(opportunityIndex + 1)
    ]

    return {
      ...state,
      addRuleAction: {
        ...state.addRuleAction,
        loading: false,
        success: true
      },
      rules: newRules
    }
  }
  case types.ADD_RULE_ACTION_REJECTED: {
    return {
      ...state,
      addRuleAction: {
        ...state.addRuleAction,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.DELETE_RULE_ACTION_REQUESTED: {
    return {
      ...state,
      deleteRuleAction: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.DELETE_RULE_ACTION_FULFILLED: {
    const { opportunityId, ruleId, actionId } = action.payload

    const opportunityIndex = state.rules.findIndex((rule) => rule.opportunityId === opportunityId)
    const opportunity = state.rules[opportunityIndex]

    const ruleIndex = opportunity.rules.findIndex((rule) => rule.ruleId === ruleId)
    const rule = opportunity.rules[ruleIndex]
    
    const newRuleActions = rule.ruleActions.filter((ruleAction) => ruleAction.actionId !== actionId)

    const newRules = [
      ...state.rules.slice(0, opportunityIndex),
      {
        ...opportunity,
        rules: [
          ...opportunity.rules.slice(0, ruleIndex),
          {
            ...rule,
            ruleActions: newRuleActions
          },
          ...opportunity.rules.slice(ruleIndex + 1)
        ]
      },
      ...state.rules.slice(opportunityIndex + 1)
    ]

    return {
      ...state,
      deleteRuleAction: {
        ...state.deleteRuleAction,
        loading: false,
        success: true
      },
      rules: newRules
    }
  }
  case types.DELETE_RULE_ACTION_REJECTED: {
    return {
      ...state,
      deleteRuleAction: {
        ...state.deleteRuleAction,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.GET_HEALTH_SYSTEM_ACTIONS_REQUESTED: {
    return {
      ...state,
      getActions: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.GET_HEALTH_SYSTEM_ACTIONS_FULFILLED: {
    return {
      ...state,
      getActions: {
        ...state.getActions,
        loading: false,
        success: true
      },
      actions: action.payload,
      activeActionSort: 'name',
      isDesc: false,
    }
  }
  case types.GET_HEALTH_SYSTEM_ACTIONS_REJECTED: {
    return {
      ...state,
      getActions: {
        ...state.getActions,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.SORT_HEALTH_SYSTEM_ACTIONS: {
    const orderByIsSame = state.activeActionSort === action.payload
    const direction = orderByIsSame
      ? state.isDesc 
        ? 'ASC'
        : 'DESC'
      : 'ASC'
    const newActions = state.actions.sort((a, b) => {
      if (direction === 'ASC') return (a[action.payload] > b[action.payload]) ? 1 :  -1
      return (a[action.payload] < b[action.payload]) ? 1 :  -1
    })

    return {
      ...state,
      actions: newActions,
      activeActionSort: action.payload,
      isDesc: direction === 'DESC',
    }
  }
  case types.CREATE_HEALTH_SYSTEM_ACTION_REQUESTED: {
    return {
      ...state,
      addAction: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.CREATE_HEALTH_SYSTEM_ACTION_FULFILLED: {
    return {
      ...state,
      addAction: {
        ...state.addAction,
        loading: false,
        success: true
      },
      actions: [
        action.payload,
        ...state.actions
      ]
    }
  }
  case types.CREATE_HEALTH_SYSTEM_ACTION_REJECTED: {
    return {
      ...state,
      addAction: {
        ...state.addAction,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.UPDATE_ACTION_ORDER: {
    const { actionId, name, value } = action.payload
    const actionIndex = state.actions.findIndex((action) => action.actionId === parseInt(actionId, 10))
    return {
      ...state,
      actions: [
        ...state.actions.slice(0, actionIndex),
        {
          ...state.actions[actionIndex],
          [name]: value
        },
        ...state.actions.slice(actionIndex + 1)
      ]
    }
  }
  case types.UPDATE_HEALTH_SYSTEM_ACTION_REQUESTED: {
    return {
      ...state,
      updateAction: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.UPDATE_HEALTH_SYSTEM_ACTION_FULFILLED: {
    const actionIndex = state.actions.findIndex((a) => a.actionId === action.payload.actionId)
    return {
      ...state,
      updateAction: {
        ...state.updateAction,
        loading: false,
        success: true
      },
      actions: [
        ...state.actions.slice(0, actionIndex),
        action.payload,
        ...state.actions.slice(actionIndex + 1)
      ]
    }
  }
  case types.UPDATE_HEALTH_SYSTEM_ACTION_REJECTED: {
    return {
      ...state,
      updateAction: {
        ...state.updateAction,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.DELETE_HEALTH_SYSTEM_ACTION_REQUESTED: {
    return {
      ...state,
      deleteAction: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.DELETE_HEALTH_SYSTEM_ACTION_FULFILLED: {
    const actionId = parseInt(action.payload, 10)
    const opportunityIndex = state.rules.findIndex((rule) => rule.rules.find((r) => r.ruleActions.find((ra) => ra.actionId === actionId)))
    let newRules = state.rules
    if (opportunityIndex > -1) {
      const ruleIndex = newRules[opportunityIndex].rules.findIndex((r) => r.ruleActions.find((ra) => ra.actionId === actionId))
      newRules = [
        ...newRules.slice(0, opportunityIndex),
        {
          ...newRules[opportunityIndex],
          rules: [
            ...newRules[opportunityIndex].rules.slice(0, ruleIndex),
            {
              ...newRules[opportunityIndex].rules[ruleIndex],
              ruleActions: newRules[opportunityIndex].rules[ruleIndex].ruleActions.filter((ra) => ra.actionId !== actionId)
            },
            ...newRules[opportunityIndex].rules.slice(ruleIndex + 1)
          ]
        },
        ...newRules.slice(opportunityIndex + 1)
      ]
    }
    return {
      ...state,
      deleteAction: {
        ...state.deleteAction,
        loading: false,
        success: true
      },
      actions: state.actions.filter((a) => a.actionId !== actionId),
      rules: newRules
    }
  }
  case types.DELETE_HEALTH_SYSTEM_ACTION_REJECTED: {
    return {
      ...state,
      deleteAction: {
        ...state.deleteAction,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.RESEND_SETUP_REQUESTED: {
    return {
      ...state,
      resendSetup: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.RESEND_SETUP_FULFILLED: {
    return {
      ...state,
      resendSetup: {
        ...state.resendSetup,
        loading: false,
        success: true
      }
    }
  }
  case types.RESEND_SETUP_REJECTED: {
    return {
      ...state,
      resendSetup: {
        ...state.resendSetup,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.RESET_HEALTH_SYSTEM_USER_STATE: {
    return {
      ...state,
      createUser: {
        loading: false,
        success: false,
        error: false
      },
      deleteUser: {
        loading: false,
        success: false,
        error: false
      },
      resendSetup: {
        loading: false,
        success: false,
        error: false
      },
      updateUser: {
        loading: false,
        success: false,
        error: false
      }
    }
  }
  case types.RESET_HEALTH_SYSTEM_RULE_STATE: {
    return {
      ...state,
      addRuleAction: {
        loading: false,
        success: false,
        error: false
      },
      deleteRuleAction: {
        loading: false,
        success: false,
        error: false
      },
      updateRule: {
        loading: false,
        success: false,
        error: false
      }
    }
  }
  case types.RESET_HEALTH_SYSTEM_ORDER_STATE: {
    return {
      ...state,
      addAction: {
        loading: false,
        success: false,
        error: false
      },
      updateAction: {
        loading: false,
        success: false,
        error: false
      },
      deleteAction: {
        loading: false,
        success: false,
        error: false
      },
      activeOrderSort: 'name',
      isDesc: false
    }
  }
  case types.GET_REPORT_REQUESTED: {
    return {
      ...state,
      getReport: {
        loading: true,
        success: false,
        error: false
      },
      reportData: {}
    }
  }
  case types.GET_REPORT_FULFILLED: {
    return {
      ...state,
      getReport: {
        loading: false,
        success: true,
        error: false
      },
      reportData: action.payload
    }
  }
  case types.GET_REPORT_REJECTED: {
    return {
      ...state,
      getReport: {
        loading: false,
        success: false,
        error: action.payload
      }
    }
  }
  default:
    return state
  }
}

export default healthSystemReducer
